import React from "react";
import Header from "../Components/Header";
import Rightcontainer from "../Components/Rightcontainer";
import { Link } from "react-router-dom";

const Support = ({ handleShow }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  return (
    <div>
      <div
        className="leftContainer"
        style={{ minHeight: "100vh", height: "100%" }}
      >
        <div className="pt-3 mt-5  Orher_page_main_section">
          <section className="premium-support-page">
            <div className="support-wrapper">
              {/* Modern Header */}
              <div className="support-hero">
                <h2 className="hero-title">
                  SUPPORT <span>CENTER</span>
                </h2>
                <p>We are available 24x7 to help you</p>
              </div>

              {/* Central Agent Profile */}
              <div className="agent-container">
                <div className="avatar-glow">
                  <img
                    src="/author.webp"
                    alt="Support"
                    className="agent-avatar"
                  />
                  <div className="online-indicator"></div>
                </div>
                <div className="agent-status">
                  <h5>Our Support Team</h5>
                  <p className="mb-0">Typically replies in 2 mins</p>
                </div>
              </div>

              <div className="contact-grid">
                {/* Telegram Link - Original Logic Ke Saath */}
                {/* <a
                  href={
                    JSON.parse(localStorage.getItem("sitSetting")) ==
                    "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                          ?.supportTelegram
                  }
                  target="_blank"
                  className="contact-tile telegram-tile"
                >
                  <div className="tile-icon">
                    <img src="/mainimage/support.jpg" alt="Telegram" />
                  </div>
                  <div className="tile-content">
                    <strong>Telegram Support</strong>
                    <span>Official Channel</span>
                  </div>
                  <div className="tile-arrow">→</div>
                </a> */}

                {/* Call Link - Original Logic Ke Saath */}
                <a
                  href={`tel:${addCaseSetting.CompanyMobile}`}
                  className="contact-tile call-tile"
                >
                  <div className="tile-icon">
                    <img src="./images/phone.png" alt="Call" />
                  </div>
                  <div className="tile-content">
                    <strong>Contact Us</strong>
                    <span>Voice Assistance</span>
                  </div>
                  <div className="tile-arrow">→</div>
                </a>

                <a
                  href={`${addCaseSetting.whatsappSupport}`}
                  className="contact-tile call-tile"
                >
                  <div className="tile-icon">
                    <img src="./images/whatsapp.png" alt="Call" />
                  </div>
                  <div className="tile-content">
                    <strong>Whatsapp</strong>
                  </div>
                  <div className="tile-arrow">→</div>
                </a>
              </div>

              <div className="support-footer">
                <p>Secure & Verified Support</p>
              </div>
            </div>
          </section>
        </div>

        {/* mail */}
        {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <a className="cxy flex-column" href="mailto:info@kingtox.in">
                    <img
                      width="50px"
                      src={process.env.PUBLIC_URL + "/images/mail.png"}
                      alt=""
                    />
                    <span className="">
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.supportMail}
                    </span>
                  </a>
                </div>
              </div> */}

        {/* whatsapp */}
        
        {/* call */}
        {/* <div className="col-6 col-lg-4 col-md-3 col-sm-12 mb-3">
                <div className="support_samll_card_btn_type">
                  <img
                    width="50px"
                    src={process.env.PUBLIC_URL + "/images/phone.png"}
                    alt=""
                  />
                  <span className="">
                    <a
                      target="_blank"
                      href={
                        JSON.parse(localStorage.getItem("sitSetting")) ==
                        "undefined"
                          ? ""
                          : "tel:" +
                            JSON.parse(localStorage.getItem("sitSetting"))
                              ?.CompanyMobile
                      }
                    >
                      {JSON.parse(localStorage.getItem("sitSetting")) ==
                      "undefined"
                        ? ""
                        : JSON.parse(localStorage.getItem("sitSetting"))
                            ?.CompanyMobile}
                    </a>
                  </span>
                </div>
              </div> */}
        {/* <div className="col-12 col-lg-12 col-md-12 col-sm-12 mb-3">
                <p className="company_address">
                  Address:
                  <span>
                    {JSON.parse(localStorage.getItem("sitSetting")) ==
                    "undefined"
                      ? ""
                      : JSON.parse(localStorage.getItem("sitSetting"))
                          ?.CompanyAddress}
                  </span>
                </p>
              </div> */}
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
